import produce from "immer";
import AuthService from '../AuthService';
import { EVO } from '../EVO';

const GET_WEATHER = 'peptalkr/weather/GET_WEATHER';
const GET_WEATHER_SUCCESS = 'peptalkr/weather/GET_WEATHER_SUCCESS';
const GET_WEATHER_FAILURE = 'peptalkr/weather/GET_WEATER_FAILURE';

export const requestWeather = () => ({ type: GET_WEATHER });
export const receiveWeather = forecasts => ({ type: GET_WEATHER_SUCCESS, forecasts });
export const receiveWeatherFail = error => ({ type: GET_WEATHER_FAILURE, error });

export const fetchforecasts = () => (dispatch) => {
    const authService = new AuthService();
    if (authService.isAuthenticated()) {
        dispatch(requestWeather());
        EVO.get('api/SampleData/WeatherForecasts')
            .then(forecasts => dispatch(receiveWeather(forecasts)))
            .catch(error => dispatch(receiveWeatherFail(error)));
    }
};

const initialState = {
    forecasts: [],
    loading: true,
    error: false,
    name: null
};

export default produce((draft, action) => {
    switch (action.type) {
        case GET_WEATHER:
            draft.loading = true;
            return;
        case GET_WEATHER_SUCCESS:
            draft.loading = false;
            draft.forecasts = action.forecasts;
            return;
        case GET_WEATHER_FAILURE:
            draft.loading = false;
            draft.error = action.error;
            return;
        default: return;
    }
}, initialState)


// WEBPACK FOOTER //
// ./src/redux/weather.js